import { useState } from "react";
import { HiOutlineGift } from "react-icons/hi2";

const GiftThumbnailContent = ({
  imageUrl,
  alt,
  iconClassName,
}: {
  imageUrl: string;
  alt: string;
  iconClassName: string;
}) => {
  const [hasImageFailed, setHasImageFailed] = useState<boolean>(false);

  if (!imageUrl || hasImageFailed) {
    return <HiOutlineGift className={`text-[#193A6A]/60 ${iconClassName}`} aria-hidden="true" />;
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      loading="lazy"
      onError={() => setHasImageFailed(true)}
      className="h-full w-full object-contain"
    />
  );
};

/** Gift image in a fixed box; shows a gift icon when there is no image or it fails to load. */
export const GiftThumbnail = ({
  imageUrl,
  alt,
  className = "h-10 w-10",
  iconClassName = "h-5 w-5",
}: {
  imageUrl?: string | null;
  alt: string;
  className?: string;
  iconClassName?: string;
}) => {
  const src = imageUrl?.trim() ?? "";
  return (
    <span
      title={src ? undefined : "No image"}
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-[#EEF5FF] p-1 ${className}`}
    >
      {/* Remount on URL change so a previously failed image is retried. */}
      <GiftThumbnailContent key={src} imageUrl={src} alt={alt} iconClassName={iconClassName} />
    </span>
  );
};
